export const languages = {
  sv: { nativeName: 'Svenska', code: 'sv' },
  no: { nativeName: 'Norsk', code: 'no' },
  dk: { nativeName: 'Dansk', code: 'dk' },
  en: { nativeName: 'English', code: 'en' },
};

export function getBrowserLanguage(browserAcceptLanguage, cookies, path) {
  const pathLanguage = getLanguageFromPath(path);

  if (pathLanguage && languages[pathLanguage]) {
    return pathLanguage;
  }

  const cookieLanguage = getUserLanguageCookie(cookies);

  if (cookieLanguage && languages[cookieLanguage]) {
    return cookieLanguage;
  }

  const languageList = {
    sv: browserAcceptLanguage?.indexOf('sv'),
    dk: browserAcceptLanguage?.indexOf('dk'),
    no: browserAcceptLanguage?.indexOf('no'),
    en: browserAcceptLanguage?.indexOf('en'),
  };

  const availableLanguagesObj = Object.keys(languageList).reduce((acc, key) => {
    const _acc = acc;
    if (languageList[key] !== -1) _acc[key] = languageList[key];
    return _acc;
  }, {});

  if (
    availableLanguagesObj &&
    Object.keys(availableLanguagesObj).length !== 0
  ) {
    return Object.keys(availableLanguagesObj).reduce((a, b) =>
      availableLanguagesObj[a] < availableLanguagesObj[b] ? a : b
    );
  } else {
    return 'sv';
  }
}

export function setUserLanguageCookie(cookies, lngPathSegment = 'sv') {
  cookies.set('language', lngPathSegment);
  return new Promise((resolve) => resolve(lngPathSegment));
}

function getUserLanguageCookie(cookies) {
  return cookies.get('language');
}

export function clearLanguageFromPath(path) {
  let output = path;
  for (const language of Object.values(languages)) {
    output = output.replace(`/${language.code}`, '');
  }
  return output;
}

function getLanguageFromPath(path) {
  return path?.substring(1, 3);
}
